export default "__VITE_PUBLIC_ASSET__5e89b54c__"